import React from 'react';

const PrivacyTerms: React.FC = () => (
  <div className="max-w-3xl mx-auto py-16 px-4">
    <h1 className="text-5xl font-extrabold mb-6 bg-gradient-to-r from-blue-600 via-purple-500 to-pink-500 bg-clip-text text-transparent drop-shadow-lg flex items-center gap-3">
      <span>🔒</span> Quicklish App Privacy Policy
    </h1>

    <div className="bg-white/80 rounded-2xl shadow-xl p-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-blue-700 flex items-center gap-2">
        <span>🔐</span> Your Privacy Matters
      </h2>
      <p className="mb-2 text-gray-700 text-lg">
        At <span className="font-bold text-blue-600">Quicklish</span>, your privacy and trust are our top priorities. We design our
        app to collect only what’s necessary to provide a great learning experience. We <span className="font-bold">do not sell</span> your data.
      </p>
    </div>

    <div className="border-l-4 border-pink-400 pl-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-pink-700 flex items-center gap-2">
        <span>📋</span> Data We Collect (App)
      </h2>
      <ul className="list-disc list-inside mb-2 text-gray-700 text-lg">
        <li><span className="font-semibold">Account:</span> email, display name, preferred language.</li>
        <li><span className="font-semibold">Learning data:</span> progress, favorites, completed items.</li>
        <li><span className="font-semibold">Device info (basic):</span> app version, crash/usage analytics to improve the app.</li>
      </ul>
      <p className="text-sm text-gray-600">
        Note: We do not access your contacts, photos, microphone or location unless a specific feature explicitly requires it and you grant permission.
      </p>
    </div>

    <div className="border-l-4 border-blue-400 pl-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-blue-700 flex items-center gap-2">
        <span>🔒</span> How We Protect Your Data
      </h2>
      <ul className="list-disc list-inside mb-2 text-gray-700 text-lg">
        <li>Secure communication over HTTPS.</li>
        <li>Industry-standard authentication and session security.</li>
        <li>Access controls to prevent unauthorized access.</li>
        <li>Limited retention—only as long as needed to provide the service.</li>
      </ul>
      <p className="text-sm text-gray-600">
        Quicklish may use trusted third-party services (e.g., analytics, hosting) solely to run the app. These providers are bound by strict data protection terms.
      </p>
    </div>

    <div className="border-l-4 border-yellow-400 pl-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-yellow-700 flex items-center gap-2">
        <span>🧩</span> App Permissions
      </h2>
      <ul className="list-disc list-inside mb-2 text-gray-700 text-lg">
        <li><span className="font-semibold">Microphone (optional):</span> only if you use voice features. Audio is used for practice and not stored unless clearly stated.</li>
        <li><span className="font-semibold">Network:</span> to sync progress and fetch learning content.</li>
        <li><span className="font-semibold">Notifications (optional):</span> to remind you about practice sessions (if enabled).</li>
      </ul>
    </div>

    <div className="border-l-4 border-green-400 pl-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-green-700 flex items-center gap-2">
        <span>📝</span> Your Rights
      </h2>
      <ul className="list-disc list-inside mb-2 text-gray-700 text-lg">
        <li>Access, update, or delete your account at any time.</li>
        <li>Export your learning data upon request.</li>
        <li>Contact us for any privacy concerns: <a href="mailto:learn.with.me.beginning@gmail.com" className="text-blue-600 underline font-bold">learn.with.me.beginning@gmail.com</a></li>
      </ul>
    </div>

    <div className="border-l-4 border-purple-400 pl-6 mb-8">
      <h2 className="text-2xl font-bold mb-2 text-purple-700 flex items-center gap-2">
        <span>🗑️</span> Deleting Your Account
      </h2>
      <p className="text-gray-700 text-lg mb-2">
        You can delete your account from within the app or by visiting the <a className="text-blue-600 underline font-semibold" href="/delete-account">Delete Account</a> page.
        Deletion is permanent and removes your profile and learning data from our active systems.
      </p>
    </div>

    <div className="mt-10 text-center">
      <span className="inline-block text-xl font-semibold text-blue-600 bg-blue-100 rounded-full px-6 py-2 shadow">
        Thank you for trusting Quicklish! 🙏
      </span>
    </div>
  </div>
);

export default PrivacyTerms; 